import { Route, Routes } from "react-router-dom";

import AddSourcePage from "./AddSourcePage";
import AllLists from "./AllLists";
import LeadListDetails from "./LeadListDetails";

export default function Lists() {
  return (
    <Routes>
      <Route path="/" element={<AllLists />} />
      <Route path="/:listId/*">
        <Route path="sources/new/:sourceType" element={<AddSourcePage />} />
        <Route path="" element={<LeadListDetails />} />
      </Route>
    </Routes>
  );
}
